(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(() => {
  let pending = false, opener = null;
  const config = () => document.querySelector('[data-cart-config]');
  const dialog = () => document.getElementById('ProctelecCartDrawer');
  const root = () => config().dataset.root.replace(/\/?$/, '/');
  function feedback(message, error = false, form = null) {
    const targets = [...document.querySelectorAll('[data-cart-feedback]')];
    if (form) targets.push(form.querySelector('[data-product-feedback]'));
    targets.filter(Boolean).forEach(p => { p.textContent = message; p.hidden = false; p.classList.toggle('cart-error',error); });
    const global = document.querySelector('[data-cart-global]');
    if (global) global.textContent = message;
  }
  function openCart() { const d=dialog(); if(d&&!d.open){opener=document.activeElement;d.showModal();document.documentElement.classList.add('cart-open');} }
  function closeCart() { const d=dialog(); if(d?.open)d.close();document.documentElement.classList.remove('cart-open');if(opener?.isConnected)opener.focus(); }
  function sections() { const page=document.querySelector('[data-cart-page]');return ['cart-drawer',...(page?[page.dataset.sectionId]:[])]; }
  function render(data, reopen) {
    if(!data.sections?.['cart-drawer'])return false;
    for(const [id,html] of Object.entries(data.sections)) {
      if(!html)continue;
      const parsed=new DOMParser().parseFromString(html,'text/html');
      const next=parsed.getElementById('shopify-section-'+id),previous=document.getElementById('shopify-section-'+id);
      if(next&&previous)previous.replaceWith(next);
    }
    const count=document.querySelector('#ProctelecCartDrawer [data-cart-count-value]')?.dataset.cartCountValue;
    if(count!==undefined)document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=count);
    if(reopen){dialog().showModal();document.documentElement.classList.add('cart-open');}
    return true;
  }
  function setBusy(value) {
    document.querySelectorAll('[data-cart-content]').forEach(el=>el.setAttribute('aria-busy',String(value)));
    document.querySelectorAll('[data-cart-quantity],[data-cart-content] button').forEach(el=>el.disabled=value);
    document.querySelectorAll('[data-cart-remove]').forEach(el=>el.setAttribute('aria-disabled',String(value)));
  }
  async function mutate(endpoint,payload,form=null) {
    if(pending)return;
    pending=true;
    const add=endpoint==='add', button=form?.querySelector('[data-add-button]'),label=button?.textContent;
    const wasOpen=Boolean(dialog()?.open);
    setBusy(true);
    if(button){button.disabled=true;button.textContent=config().dataset.adding;}
    feedback(config().dataset[add?'adding':'updating'],false,form);
    let committed=false;
    try {
      const response=await fetch(root()+'cart/'+endpoint+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({...payload,sections:sections(),sections_url:location.pathname})});
      const data=await response.json();
      if(!response.ok)throw new Error(typeof data.description==='string'?data.description:config().dataset.error);
      committed=true;
      if(add)opener=button;
      if(!render(data,add||wasOpen)){location.assign(root()+'cart');return;}
      feedback(config().dataset[add?'added':'updated'],false,form);
    } catch(error) {
      feedback(committed?config().dataset.changed:(error.message||config().dataset.error),true,form);
      document.querySelectorAll('[data-cart-quantity]').forEach(input=>input.value=input.dataset.original);
    } finally {
      pending=false;setBusy(false);
      if(button?.isConnected){button.disabled=button.dataset.available!=='true';button.textContent=label;}
    }
  }
  document.addEventListener('submit',event=>{
    const form=event.target.closest('[data-product-form]');if(!form)return;
    event.preventDefault();if(pending||form.querySelector('[data-add-button]')?.disabled)return;
    const data=new FormData(form),id=String(data.get('id')||''),quantity=Number(data.get('quantity'));
    if(!/^\d+$/.test(id)||!Number.isInteger(quantity)||quantity<1){feedback(config().dataset.error,true,form);return;}
    mutate('add',{items:[{id,quantity}]},form);
  });
  document.addEventListener('click',event=>{
    const open=event.target.closest('[data-cart-open]');if(open&&dialog()?.showModal){event.preventDefault();openCart();return;}
    if(event.target.closest('[data-cart-close]')){closeCart();return;}
    const step=event.target.closest('[data-quantity-step]');
    if(step){const input=step.parentElement.querySelector('input');if(input&&!input.disabled){input.value=Math.max(Number(input.min)||0,Number(input.value||0)+Number(step.dataset.quantityStep));input.dispatchEvent(new Event('change',{bubbles:true}));}return;}
    const remove=event.target.closest('[data-cart-remove]');if(remove){event.preventDefault();if(!pending)mutate('change',{id:remove.dataset.key,quantity:0});}
    if(event.target===dialog()){const box=dialog().getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)closeCart();}
  });
  document.addEventListener('change',event=>{
    const input=event.target.closest('[data-cart-quantity]');if(!input)return;
    const quantity=Number(input.value);if(!Number.isInteger(quantity)||quantity<0){input.value=input.dataset.original;return;}
    mutate('change',{id:input.dataset.key,quantity});
  });
  document.addEventListener('cancel',event=>{if(event.target.id==='ProctelecCartDrawer'){event.preventDefault();closeCart();}},true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){const name=new URLSearchParams(window.location.search).get('product'),field=document.querySelector('[data-interest-label]');if(name&&field&&!field.value&&/^[a-z0-9-]{1,120}$/.test(name))field.value=field.dataset.interestLabel+' '+name+'\n\n';});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(()=>{const drawer=document.getElementById('ProctelecMenu'),trigger=document.querySelector('[data-menu-open]');if(!drawer||!trigger)return;let opener;
trigger.addEventListener('click',()=>{opener=document.activeElement;drawer.showModal();trigger.setAttribute('aria-expanded','true');document.documentElement.classList.add('nav-open');});
const close=()=>drawer.close();drawer.querySelector('[data-menu-close]').addEventListener('click',close);
drawer.addEventListener('click',e=>{if(e.target===drawer){const r=drawer.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close();}});
drawer.addEventListener('close',()=>{trigger.setAttribute('aria-expanded','false');document.documentElement.classList.remove('nav-open');opener?.focus();});
drawer.querySelectorAll('a').forEach(link=>link.addEventListener('click',close));
matchMedia('(min-width: 961px)').addEventListener('change',e=>{if(e.matches&&drawer.open)close();});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('change',event=>{if(event.target.id!=='Variant')return;const selected=event.target.selectedOptions[0],available=selected.dataset.available==='true';document.getElementById('ProductPrice').textContent=selected.dataset.price;document.querySelector('[data-sticky-price]').textContent=selected.dataset.price;const button=document.querySelector('[data-add-button]');button.disabled=!available;button.dataset.available=String(available);document.querySelector('[data-buy-controls]').hidden=!available;document.querySelector('[data-unavailable-panel]').hidden=available;document.querySelector('[data-sticky-buy]').hidden=!available;document.querySelector('[data-sticky-ask]').hidden=available;});

  } catch(e) { console.error(e); }
})();
})();
